export default {
  OPERACION_PROYECTO_USUARIO: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
